import util from '@/utils/classToObject'
import { ISocketState } from './state'

export class SocketGetter {
  public isConnected(state: ISocketState) {
    return state.isConnected
  }

  public keepAliveTimoutId(state: ISocketState) {
    return state.keepAliveTimoutId
  }

  public wasOffline(state: ISocketState) {
    return state.wasOffline
  }

  public connectedDate(state: ISocketState) {
    return state.connectedDate
  }

  public socketMessage(state: ISocketState) {
    return state.message
  }
  public reconnectError(state: ISocketState) {
    return state.reconnectError
  }
}

export default util.classToObject(SocketGetter)
